import {connect} from 'react-redux';
import {LoadGelBoxSolution as Component} from './LoadGelBoxSolution';
import {
  showModal,
  loadDNALadder
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    //solutions: state.notebook.protocolSection.scene.apparatus.solutions
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    loadDNALadder: (data) => {
      dispatch(loadDNALadder(data))
    }
  };
}

export const LoadGelBoxSolution = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
